import { DelwinNameAndDate } from '@app/components/various/DelwinNameAndDate';
import { CollapsibleListCell } from '@app/components/various/Table';
import { DeliveryWindow } from '@typings';

interface Props {
  deliveryWindows: DeliveryWindow.Mixed[];
}

export const DeliveryWindowsColumn = ({ deliveryWindows }: Props) => {
  return (
    <CollapsibleListCell
      items={deliveryWindows.map(deliveryWindow => (
        <DelwinNameAndDate key={deliveryWindow.deliveryWindow} insertCommas deliveryWindow={deliveryWindow} />
      ))}
    />
  );
};
